import { render, staticRenderFns } from "./StoryMedia.vue?vue&type=template&id=1543e376&scoped=true"
import script from "./StoryMedia.vue?vue&type=script&lang=ts"
export * from "./StoryMedia.vue?vue&type=script&lang=ts"
import style0 from "./StoryMedia.vue?vue&type=style&index=0&id=1543e376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1543e376",
  null
  
)

export default component.exports